import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Performance from "../pages/performance/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Portfolio from "../pages/portfolio/page";
import Culture from "../pages/culture/page";
import Partner from "../pages/partner/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/performance",
    element: <Performance />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/culture",
    element: <Culture />,
  },
  {
    path: "/partner",
    element: <Partner />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
